import { DatePickerInput, type DatePickerInputProps } from '@mantine/dates';
import {
  toRocDateLabel,
  toRocDecadeLabel,
  toRocMonthLabel,
  toRocYearCellLabel,
  toRocYearLabel,
} from '../utils/rocDate.ts';

const ROC_MIN_DATE = '1912-01-01';

const RocDateInput = ({ value, ...props }: DatePickerInputProps) => {
  const adDate = typeof value === 'string' ? value : null;

  return (
    <DatePickerInput
      value={value}
      minDate={ROC_MIN_DATE}
      description={adDate ? `西元 ${adDate}` : undefined}
      valueFormatter={({ date }) =>
        typeof date === 'string' ? toRocDateLabel(date) : ''
      }
      monthLabelFormat={toRocMonthLabel}
      yearLabelFormat={toRocYearLabel}
      decadeLabelFormat={toRocDecadeLabel}
      getYearControlProps={(date) => ({ children: toRocYearCellLabel(date) })}
      {...props}
    />
  );
};

export { RocDateInput };
